"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expireOrganizerCookie = exports.getOrganizerIdFromCookie = exports.hasAlreadyChosen = exports.shouldShowGDPRModal = exports.createFollowNotificationContainer = exports.createLoginModalContainer = exports.createGDPRContainer = void 0;

var _cookiesJs = _interopRequireWildcard(require("cookies-js"));

var _path = require("js-utils/path");

var _constants = require("../constants");

var _destinationUtils = require("@eb/destination-utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getContainerParent = function getContainerParent(parentClassName) {
  if (typeof parentClassName === 'string' && document.getElementsByClassName(parentClassName).length) {
    return document.getElementsByClassName(parentClassName)[0];
  }

  return document.body;
};

var createContainerOnce = function createContainerOnce(className, parentClassName) {
  var containers = document.getElementsByClassName(className);
  var container;

  if (containers.length > 0) {
    container = containers[0];
  } else {
    var newDiv = document.createElement('div');
    newDiv.classList.add(className);
    container = getContainerParent(parentClassName).appendChild(newDiv);
  }

  return container;
};

var createGDPRContainer = function createGDPRContainer() {
  return createContainerOnce(_constants.gdprModalContainerClassName);
};

exports.createGDPRContainer = createGDPRContainer;

var createLoginModalContainer = function createLoginModalContainer() {
  return createContainerOnce(_constants.loginModalContainerClassName);
};

exports.createLoginModalContainer = createLoginModalContainer;

var createFollowNotificationContainer = function createFollowNotificationContainer(parentClassName) {
  return createContainerOnce(_constants.followNotificationContainerClassName, parentClassName);
}; // Cookies


exports.createFollowNotificationContainer = createFollowNotificationContainer;

var hasFollowOrganizerCookie = function hasFollowOrganizerCookie() {
  var notificationCookieValue = _cookiesJs.default.get(_constants.NOTIFICATION_COOKIE);

  return notificationCookieValue !== undefined;
};

var explicitOptIn = 1;
var explicitOptOut = 2; // Array with the values if the user has explicitly opted in or out for receiving notifications from an organizer

var explicitChoices = [explicitOptIn, explicitOptOut]; // TODO CHECK ASYNCHRONISM

var shouldShowGDPRModal = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var isGDPRCountry,
        userId,
        launchCommSettingsFollowAction,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isGDPRCountry = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
            userId = _args.length > 1 ? _args[1] : undefined;
            launchCommSettingsFollowAction = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;

            if (isGDPRCountry) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", false);

          case 7:
            if (!launchCommSettingsFollowAction) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", hasAlreadyChosen(userId).then(function (hasChosen) {
              return hasChosen;
            }));

          case 11:
            return _context.abrupt("return", !hasFollowOrganizerCookie());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function shouldShowGDPRModal() {
    return _ref.apply(this, arguments);
  };
}();

exports.shouldShowGDPRModal = shouldShowGDPRModal;

var hasAlreadyChosen = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId) {
    var hasChosen, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hasChosen = false;
            _context2.prev = 1;
            _context2.next = 4;
            return (0, _destinationUtils.getFollowOrganizerStatus)(userId);

          case 4:
            response = _context2.sent;
            hasChosen = explicitChoices.includes(response['preferences'][0]['global_preference']) && explicitChoices.includes(response['preferences'][1]['global_preference']);
            _context2.next = 10;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);

          case 10:
            return _context2.abrupt("return", !hasChosen);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function hasAlreadyChosen(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.hasAlreadyChosen = hasAlreadyChosen;

var getOrganizerIdFromCookie = function getOrganizerIdFromCookie() {
  return _cookiesJs.default.get(_constants.ORGANIZER_COOKIE);
};

exports.getOrganizerIdFromCookie = getOrganizerIdFromCookie;

var expireOrganizerCookie = function expireOrganizerCookie() {
  return (0, _cookiesJs.expire)(_constants.ORGANIZER_COOKIE, {
    path: (0, _path.getUrlPath)()
  });
};

exports.expireOrganizerCookie = expireOrganizerCookie;